import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { CreateContractorFileButton } from './CreateContractorFileButton'
import { colors } from 'src/theme'
import EmptyImage from 'src/assets/images/empty-files.svg'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

interface Props {
  contractorId: string
  onUpdate(): void
}

export const EmptyFilesComponent = ({ contractorId, onUpdate }: Props) => {
  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`bg-white rounded-2xl px-4 pt-6 pb-4 flex flex-col items-center h-auto justify-center`}
    >
      <img src={EmptyImage} alt="empty activity log" css={tw`w-[210px] mb-4`} />
      <Typography variant="h4" color="black" css={tw`mb-0.5`}>
        No files yet.
      </Typography>
      <Typography
        textAlign="center"
        variant="body2"
        color={colors.GRAY_COOL_GRAY}
        css={tw`w-[270px] mb-4`}
      >
        Add a file to start sharing documents, resources, or key attachments.
      </Typography>
      {hasPermission(UserPermission.ContractorFilesCreate) && (
        <CreateContractorFileButton contractorId={contractorId} onUpdate={onUpdate} />
      )}
    </div>
  )
}

export const EmptyFiles = memo(EmptyFilesComponent)
